import { io, Socket } from 'socket.io-client';
import { API_CONFIG } from '../../config/constants';

let socket: Socket | null = null;

export const getRealtimeClient = () => {
  if (!socket) {
    socket = io(API_CONFIG.BASE_URL, {
      auth: {
        token: localStorage.getItem('token') || undefined,
      },
      transports: ['websocket', 'polling'],
    });
  } else if (!socket.connected) {
    socket.auth = { token: localStorage.getItem('token') || undefined };
    socket.connect();
  }

  return socket;
};

export const disconnectRealtimeClient = () => {
  if (socket) {
    socket.disconnect();
  }
};
